import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconReportNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M15 13.334V9.167c0-2.558-1.367-4.7-3.75-5.267v-.567c0-.691-.558-1.25-1.25-1.25s-1.25.559-1.25 1.25V3.9C6.358 4.467 5 6.6 5 9.167v4.167L3.333 15v.834h13.334V15L15 13.334zm-4.167 0H9.167v-1.667h1.666v1.667zm0-3.334H9.167V6.667h1.666V10zM10 18.334c.917 0 1.667-.75 1.667-1.667H8.333c0 .916.742 1.666 1.667 1.666z"
	})
});
export default SvgIconReportNotification;
